import React from 'react';
import PropTypes from 'prop-types';
import { LazyImage } from 'project/lazy-image';
import { SpriteSvg } from 'project/sprite-svg';
import { LiveEventSelect } from 'components/live-event-select';
import { SearchAutocomplete } from 'components/search-autocomplete';

const TeeTimesBar = (
    {
        choices,
        nextOutDate,
        search,
        sortOrder,
        setRound,
        reverseOrder,
        showNextOut,
        showFavourites,
        toggleFavourites,
        patronLogo
    }
) => {
    const nextOutCss = !nextOutDate ? 'is-disabled' : '';
    const favouritesCss = showFavourites ? 'is-active' : '';
    const stateCss = search.isPredictive ? 'is-predictive' : '';
    const reverseOrderCss = sortOrder === 'DESC' ? 'is-active' : '';

    return (
        <div className={`tee-times-bar ${stateCss}`}>
            <div className="tee-times-bar__header">
                <div className="tee-times-bar__left-line">
                    {
                        choices.length === 1 &&
                        <div className="tee-times-bar__single-round single-round">{choices[0].label}</div>
                    }
                    {
                        choices.length > 1 &&
                        <div className="tee-times-bar__dropdown">
                            <LiveEventSelect choices={choices} onChange={setRound} />
                        </div>
                    }
                    <div className="tee-times-bar__patron--desktop ntt-data-logo">
                        <LazyImage image={patronLogo} />
                    </div>
                </div>
                <div className="tee-times-bar__right-line">
                    <div className="tee-times-bar__search">
                        <SearchAutocomplete
                            suggestions={search.suggestions}
                            defaultCallback={search.defaultCb}
                            onToggleState={search.onToggleState}
                        />
                    </div>
                    <button
                        className={`tee-times-bar__favorites button-round button-round--base is-border-white ${favouritesCss}`}
                        type="button"
                        onClick={toggleFavourites}
                    >
                        <SpriteSvg iconName="star" width="14" height="14" />
                    </button>
                    <button
                        className={`tee-times-bar__order button-round button-round--toggle is-border-white ${reverseOrderCss}`}
                        type="button"
                        onClick={reverseOrder}
                    >
                        <span className="button-content button-content--icon">
                            <span>Reverse order</span>
                            <SpriteSvg iconName="sorting" width="15" height="11" />
                        </span>
                    </button>
                </div>
            </div>
            <div className="tee-times-bar__footer">
                <button
                    className={`tee-times-bar__next-out ${nextOutCss}`}
                    type="button"
                    onClick={showNextOut}
                    disabled={!nextOutDate}
                >
                    <span>
                        <span>Next out&nbsp;</span>
                        <SpriteSvg iconName="arr-down" width="15" height="11" />
                    </span>
                </button>
                <div className="tee-times-bar__patron--mobile ntt-data-logo">
                    <LazyImage image={patronLogo} />
                </div>
            </div>
        </div>
    );
};

TeeTimesBar.propTypes = {
    choices: PropTypes.array,
    nextOutDate: PropTypes.string,
    setRound: PropTypes.func,
    reverseOrder: PropTypes.func.isRequired,
    showNextOut: PropTypes.func.isRequired,
    toggleFavourites: PropTypes.func.isRequired
};

export default TeeTimesBar;
